import getSizeFromSrc from '@anm/helpers/getSizeFromSrc';
import isRetina from '@anm/helpers/is/isRetina';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

const useProjectPreview = (projectId: string) => {
  const smallestPreview = useSelector(state => videoFolderSelectors.selectSmallestProjectPreview(state, projectId));

  const smallestSize = !!smallestPreview && getSizeFromSrc(smallestPreview);

  const retinaSize = useSelector(
    state => smallestSize && videoFolderSelectors.selectProjectPreviewBySize(state, projectId, smallestSize * 2)
  );

  const selectPreview = () => (isRetina() && smallestSize ? retinaSize || undefined : smallestPreview);

  const [preview, setPreview] = useState<string | undefined>(() => selectPreview());

  useEffect(() => {
    setPreview(selectPreview());
  }, [projectId, smallestPreview]);

  return preview;
};

export default useProjectPreview;
